<template>
<div class="row clearfix">
  <div v-if="loading">
    <BlockUI :message="blockuimsg"></BlockUI>
  </div>
  <div class="card">
    <div class="body">
    <div class="col-lg-12">
      <exercises ref="exercise_child" :exercise="exercise" :engine="engine"></exercises>
      <br>
      <ValidationObserver ref="formValidation">
      <div class="row">
            <div class="col-md-4">
              <div class="mb-2 font-weight-bold">Configuración</div>
               <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.VERBAL_ORAL"
                id="verbaloral">
                <label class="custom-control-label" for="verbaloral">Verbal oral</label>
              </div>
               <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.VERBAL_ESCRITO"
                id="VERBAL_ESCRITO">
                <label class="custom-control-label" for="VERBAL_ESCRITO">Verbal escrito</label>
              </div>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.SIMPLIFICAR_RESULTADO"
                id="SIMPLIFICAR_RESULTADO">
                <label class="custom-control-label" for="SIMPLIFICAR_RESULTADO">Simplificar resultado</label>
              </div>
            </div>
            <div class="col-md-4">
              <div class="mb-2 font-weight-bold">Respuestas</div>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.RESP_VERBAL_ORAL"
                id="respverbaloral">
                <label class="custom-control-label" for="respverbaloral">
                  Respuesta Verbal Oral</label>
              </div>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.RESP_VERBAL_ESCRITO"
                id="RESP_VERBAL_ESCRITO">
                <label class="custom-control-label" for="RESP_VERBAL_ESCRITO">Respuesta Verbal Escrita</label>
              </div>
            </div>
            <div class="col-md-4">
              <div>
                Máximo decimales
                <b-form-input type="number"
                        v-model="configuration.MAX_DECIMALES">
                        </b-form-input>
                </div>
                <div>
                Redondear<select class="form-control" v-model="configuration.REDONDEAR">
                  <option value="0">Truncar </option>
                  <option value="1">Redondear</option>
                </select>
              </div>
            </div>
      </div>
      <br>
      <hr>
      <b-row>
        <b-col style="text-align:center">
          <a href="https://www.hostmath.com/" target="_blank"><i class="zmdi zmdi-link" /> Editor de Latex</a>
          <b-button @click="bShowLatex = !bShowLatex" class="btn btn-warning ml-2 p-1" size="sm">Ver latex</b-button>
          <span class="mx-3">|</span>
          <strong>Operaciones del ejercicio</strong>
          <b-button v-if="arrayEleOperation.length > 1" @click="removeArrayEleOperation()" class="btn btn-danger ml-2" size="sm">-</b-button>
          <b-button @click="addArrayEleOperation()" class="btn btn-primary ml-2" size="sm">+</b-button>
        </b-col>
      </b-row>
      <br>
      <b-row class="justify-content-center">
          <b-col md="7" style="text-align:center"><h6>Ecuación</h6></b-col>
          <b-col md="3" style="text-align:center" v-if="bShowLatex"><h6>Visualización</h6></b-col>
          <b-col md="2" style="text-align:center"><h6>Resultado</h6></b-col>
      </b-row>
      <div>
        <div v-for="(operation, index) in arrayEleOperation" v-bind:key="index">
            <b-row class="justify-content-center" style="margin-bottom: 10px">
              <b-col md="7">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <b-form-input type="text"
                      v-bind:id="'ECUACION' + index"
                      v-model="arrayEleOperation[index].ECUACION" />
                  <span class="validation-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>
              <b-col md="3" style="text-align:center" v-if="bShowLatex">
                <div v-katex="arrayEleOperation[index].ECUACION"></div>
              </b-col>
              <b-col md="2">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <b-form-input type="text"
                      v-bind:id="'RESULTADO' + index"
                      v-model="arrayEleOperation[index].RESULTADO" />
                  <span class="validation-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>
            </b-row>
        </div>
      </div>
      <br>
      <b-row>
        <b-col class="text-center">
          <button v-on:click="saveStorage" :disabled="arrayEleOperation.length < 1" class="btn btn-info btn-lg">
          Guardar
        </button>
        </b-col>
      </b-row>
      </ValidationObserver>
    </div>
    </div>
  </div>
</div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import exercises from '../../exercises/exercise.vue';
import engineMixin from '../../../../mixins/engine';

extend('required', {
  ...required,
  message: 'Campo obligatorio.',
});

export default {
  props: {
    engine: Number,
    exercise: Object,
    type: String,
  },
  mixins: [engineMixin],
  components: {
    exercises,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      bShowLatex: false,
      arrayEleOperation: [],
      // Mapear con los campos de la tabla SUMARESTAALG_CONF
      configuration: {
        ID: null,
        VERBAL_ORAL: false,
        VERBAL_ESCRITO: false,
        RESP_VERBAL_ORAL: false,
        RESP_VERBAL_ESCRITO: false,
        SIMPLIFICAR_RESULTADO: true,
        MAX_DECIMALES: 2,
        REDONDEAR: 1,
        EJERCICIOS_ID: -1,
      },
    };
  },
  methods: {
    removeArrayEleOperation() {
      this.arrayEleOperation.pop();
    },
    addArrayEleOperation() {
      this.arrayEleOperation.push({
        POSICION: this.arrayEleOperation.length + 1,
        ECUACION: null,
        RESULTADO: null,
      });
    },
    async getMotorData(id) {
      this.loading = true;

      try {
        const response = await this.axios.get('resolutionequations/getresolutionequations', {
          params: {
            ejercicios_id: id,
          },
        });
        this.configuration = response.data.config;
        response.data.elements.forEach((element) => {
          this.arrayEleOperation.push({
            POSICION: element.POSICION,
            ECUACION: element.ECUACION,
            RESULTADO: element.RESULTADO,
          });
        });
      } catch (e) {
        this.$toasted.show('Ocurrió un error al leer el ejercicio', { type: 'warning' });
      }

      this.loading = false;
    },
  },
  async mounted() {
    if (this.exercise !== null && (this.exercise.ID !== null && this.exercise.ID !== undefined)) {
      await this.getMotorData(this.exercise.ID);
    }
    // Read from storage data
    this.readFromStorage(this.type);
    this.updatedNumOperation();
  },
};
</script>
